import React, { useEffect, useRef, useState } from 'react';
import { default as __ } from '../../utils';
import { colors } from '../../styles';
import Avatar from '../../components/padel/avatar';

const config = {
  initial: 1,
  key: 'avatarColor',
  options: [
    { value: colors.accent, label: '1' },
    { value: colors.ultrapurple, label: '3' },
    { value: colors.purple, label: '5' },
    { value: colors.accent_alpha, label: '6' },
  ],
};

const Option = props => {
  const { cb, label, value, selected } = props;
  return (
    <button
      className="io-unbutton io-button-pill"
      type="button"
      onClick={() => cb(value)}
    >
      <svg viewBox={`-4 -4 44 44`} width="44" height="44">
        <circle fill={value} cx="18" cy="18" r="20" />
        {selected && <circle fill={colors.ultrablack} cx="18" cy="18" r="10" />}
      </svg>
    </button>
  );
};

const AvatarCustomize = props => {
  const [theme, setTheme] = __.usePersistedState('theme', colors.accent_alpha);

  const [currentValue, currentUpdater] = __.useControllableProp({
    updater: onChange,
    defaultValue:
      theme || __.unwrapIterable(config.options[config.initial]).value,
  });

  function onChange(upcoming) {
    currentUpdater(upcoming);
  }

  useEffect(() => {
    setTheme(currentValue);
  }, [currentValue]);

  return (
    <div className="small-container owl">
      <div className="row-around align-center">
        <Avatar.Big variant="you" shade={currentValue} {...props} />
        <div
          style={{ maxWidth: '144px' }}
          className="flex-wrap row-start align-start"
        >
          {config.options.map((opt, i) => (
            <Option
              key={opt.label}
              cb={x => onChange(x)}
              selected={opt.value === currentValue}
              {...opt}
            />
          ))}
        </div>
      </div>
      <br />
    </div>
  );
};

export default AvatarCustomize;
